module.exports = __webpack_public_path__ + "img/icn_brand18.ca40a7cf.svg";